<script setup>
import { computed } from "vue";

const props = defineProps({
  total: {
    type: Number,
    required: true
  },
  count: {
    type: Number,
    required: true
  },
  color: {
    type: String,
    required: true,
    validator: (value) => ["primary", "red"].includes(value)
  }
});

const width = computed(() => (props.count / props.total) * 100);
</script>

<template>
  <div class="quiz-answer-summary">
    <span
      v-if="props.count > 0"
      class="quiz-answer-summary__bar"
      :class="`quiz-answer-summary__bar--${props.color}`"
      :style="{ width: `${width}%` }"
    ></span>
    <span>{{ props.count }}</span>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.quiz-answer-summary {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  color: @colors[@black];
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.75rem;
  gap: 5px;
}

.quiz-answer-summary__bar {
  display: inline-block;
  height: 8px;
  border-radius: 8px;

  &--primary {
    background-color: rgb(@theme-colors[@primary][base]);
  }

  &--red {
    background-color: rgb(@theme-colors[@red][base]);
  }
}
</style>
